import { render, staticRenderFns } from "./car-flag.vue?vue&type=template&id=442f179b&scoped=true&"
import script from "./car-flag.vue?vue&type=script&lang=js&"
export * from "./car-flag.vue?vue&type=script&lang=js&"
import style0 from "./car-flag.vue?vue&type=style&index=0&id=442f179b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f179b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
